<template>
  <div class="bonus-pool-page">
    <van-tabs
      v-model="typeIndex"
      title-active-color="#3283fa"
      color="#3283fa"
      :sticky="true"
      :swipe-threshold="2"
      @change="setType"
    >
      <van-tab class="list" v-for="(type, key) in types" :key="type.title" :title="type.title">
        <div v-if="typeIndex === 0" class="brand">
          <div>
            <div class="brand-info bottom-line" v-for="(item, index) in StepList" :key="item.id">
              <img :src="avatarUrl" alt />
              <div class="info">
                <div class="info-right">
                  <span class="name">{{item.name}}</span>
                  <div>
                    <span @click="checkStage(item.id)" v-if="!item.cleared">编辑阶段任务 ></span>
                    <span @click="editStage(item.id)" v-else>阶段已结束，查看执行情况 ></span>
                  </div>
                </div>
                <div class="f fbt">
                  <span>
                    <span class="word">开始</span>
                    {{item.startTime}}
                  </span>
                  <!-- -->
                  <span
                    style="color: #5293fd;"
                    v-if="!item.cleared"
                    @click="editStage(item.id)"
                  >查看执行情况 ></span>
                </div>
                <span>
                  <span class="word">结束</span>
                  {{item.finishTime}}
                </span>
              </div>
            </div>
          </div>

          <div class="sure-btn">
            <van-button type="info" @click="addStage">添加一个阶段</van-button>
          </div>
        </div>

        <div v-if="typeIndex === 1" class="bonus">
          <van-cell
            title="活动品牌与导购员"
            value="查看参与情况"
            is-link
            :to="{ name: 'kpi.brand.staff', query: { activity_id: activity.id }}"
          />

          <div class="tip">活动奖金设置</div>
          <van-cell-group class="bonus-cell-group">
            <van-cell title="品牌奖励豆总基金池" :value="financeChargeConfigVO.brandBonusBeanTotalPool||0" />
            <van-cell title="导购员奖励总豆基金池" :value="financeChargeConfigVO.staffBonusBeanTotalPool||0" />
            <van-cell title="品牌惩罚总承诺金" :value="financeChargeConfigVO.penaltyTotalMoney||0" />
            <van-cell
              title="其他推广总费用"
              :value="financeChargeConfigVO.otherPromotionExpensesTotalMoney||0"
            />
            <van-cell title="直播间红包总金额" :value="financeChargeConfigVO.liveRedPackageTotalMoney||0" />
          </van-cell-group>

          <div class="tip bottom-line">奖励豆设置</div>
          <div class="field">
            <div class="input list">
              <div>浏览</div>
              <van-field type="number" v-model.number="actKpiVO.viewBean" />
            </div>
            <div class="input list">
              <div>裂变</div>
              <van-field type="number" v-model.number="actKpiVO.fissionBean" />
            </div>
          </div>
          <div class="field">
            <div class="input list">
              <div>报名</div>
              <van-field type="number" v-model.number="actKpiVO.enrollmentBean" />
            </div>
            <div class="input list">
              <div>售券</div>
              <van-field type="number" v-model.number="actKpiVO.cardBean" />
            </div>
          </div>
          <div class="field">
            <div class="input list">
              <div>秒杀</div>
              <van-field type="number" v-model.number="actKpiVO.seckillUserBean" />
            </div>
            <div class="input list">
              <div>集赞</div>
              <van-field type="number" v-model.number="actKpiVO.thumbBean" />
            </div>
          </div>
          <div class="field">
            <div class="input list">
              <div>进入直播间</div>
              <van-field type="number" v-model.number="actKpiVO.liveViewBean" />
            </div>
            <div class="input list">
              <div>直播下订</div>
              <van-field type="number" v-model.number="actKpiVO.liveOrderCusBean" />
            </div>
          </div>
          <div class="field">
            <div class="input list">
              <div>直播自签单</div>
              <van-field type="number" v-model.number="actKpiVO.liveSelfOrderBean" />
            </div>
            <div class="input list">
              <div>直播贡献单</div>
              <van-field type="number" v-model.number="actKpiVO.liveOtherOrderBean" />
            </div>
          </div>
          <div class="field">
            <div class="input list">
              <div>直播自签转单</div>
              <van-field type="number" v-model.number="actKpiVO.liveSelfOrderChangeBean" />
            </div>
            <div class="input list">
              <div>直播贡献转单</div>
              <van-field type="number" v-model.number="actKpiVO.liveOtherOrderChangeBean" />
            </div>
          </div>
          <div class="field">
            <div class="input list">
              <div>过程自签单</div>
              <van-field type="number" v-model.number="actKpiVO.processSelfOrderBean" />
            </div>
            <div class="input list">
              <div>过程贡献单</div>
              <van-field type="number" v-model.number="actKpiVO.processDevoteOrderBean" />
            </div>
          </div>
          <div class="field">
            <div class="input list">
              <div>直播预约</div>
              <van-field type="number" v-model.number="actKpiVO.appointmentBean" />
            </div>
          </div>
          <div class="btn">
            <van-button type="info" @click="saveDetail">奖励豆设置</van-button>
          </div>

          <div class="tip bottom-line">奖励金设置</div>
          <div class="field">
            <div class="input list money">
              <div>浏览</div>
              <div>
                <!-- <input type="number" disabled v-model.number="actKpiVO.viewBonus" /> -->
                <span>{{actKpiVO.viewBonus}}元/次</span>
              </div>
            </div>
            <div class="input list money">
              <div>裂变</div>
              <div>
                <!-- <input type="number" disabled v-model.number="actKpiVO.fissionBonus" /> -->
                <span>{{actKpiVO.fissionBonus}}元/个</span>
              </div>
            </div>
          </div>
          <div class="field no-line">
            <div class="input list money">
              <div>报名</div>
              <div>
                <!-- <input type="number" disabled v-model.number="actKpiVO.enrollmentBonus" /> -->
                <span>{{actKpiVO.enrollmentBonus}}元/次</span>
              </div>
            </div>
            <div class="input list money">
              <div>售券</div>
              <div>
                <!-- <input type="number" disabled v-model.number="actKpiVO.cardBonus" /> -->
                <span>{{actKpiVO.cardBonus}}元/次</span>
              </div>
            </div>
          </div>

          <div class="field no-line">
            <div class="input list money">
              <div>秒杀</div>
              <div>
                <!-- <input type="number" disabled v-model.number="actKpiVO.seckillUserBonus" /> -->
                <span>{{actKpiVO.seckillUserBonus}}元/个</span>
              </div>
            </div>
            <div class="input list money">
              <div>集赞</div>
              <div>
                <!-- <input type="number" disabled v-model.number="actKpiVO.thumbBonus" /> -->
                <span>{{actKpiVO.thumbBonus}}元/个</span>
              </div>
            </div>
          </div>
          <div class="field no-line">
            <div class="input list money">
              <div>进入直播间</div>
              <div>
                <!-- <input type="number" disabled v-model.number="actKpiVO.liveViewBean" /> -->
                <span>{{actKpiVO.liveViewBean}}元/人</span>
              </div>
            </div>
            <div class="input list money">
              <div>直播下订</div>
              <div>
                <!-- <input type="number" disabled v-model.number="actKpiVO.liveOrderCusBonus" /> -->
                <span>{{actKpiVO.liveOrderCusBonus}}元/单</span>
              </div>
            </div>
          </div>
          <div class="field no-line">
            <div class="input list money">
              <div>直播自签单</div>
              <div>
                <!-- <input type="number" disabled v-model.number="actKpiVO.liveSelfOrderBonus" /> -->
                <span>{{actKpiVO.liveSelfOrderBonus}}元/单</span>
              </div>
            </div>
            <div class="input list money">
              <div>直播贡献单</div>
              <div>
                <!-- <input type="number" disabled v-model.number="actKpiVO.liveOtherOrderBonus" /> -->
                <span>{{actKpiVO.liveOtherOrderBonus}}元/单</span>
              </div>
            </div>
          </div>
          <div class="field no-line">
            <div class="input list money">
              <div>直播自签转单</div>
              <div>
                <!-- <input type="number" disabled v-model.number="actKpiVO.liveSelfOrderChangeBonus" /> -->
                <span>{{actKpiVO.liveSelfOrderChangeBonus}}元/单</span>
              </div>
            </div>
            <div class="input list money">
              <div>直播贡献转单</div>
              <div>
                <!-- <input type="number" disabled v-model.number="actKpiVO.liveOtherOrderChangeBonus" /> -->
                <span>{{actKpiVO.liveOtherOrderChangeBonus}}元/单</span>
              </div>
            </div>
          </div>
          <div class="field no-line">
            <div class="input list money">
              <div>过程自签单</div>
              <div>
                <!-- <input type="number" disabled v-model.number="actKpiVO.processSelfOrderBonus" /> -->
                <span>{{actKpiVO.processSelfOrderBonus}}元/单</span>
              </div>
            </div>
            <div class="input list money">
              <div>过程贡献单</div>
              <div>
                <!-- <input type="number" disabled v-model.number="actKpiVO.processDevoteOrderBonus" /> -->
                <span>{{actKpiVO.processDevoteOrderBonus}}元/单</span>
              </div>
            </div>
          </div>
          <div class="field no-line">
            <div class="input list money">
              <div>直播预约</div>
              <div>
                <!-- <input type="number" disabled v-model.number="actKpiVO.processSelfOrderBonus" /> -->
                <span>{{actKpiVO.appointmentBonus}}元/单</span>
              </div>
            </div>
          </div>

          <div class="tip bottom-line">积分设置</div>
          <div class="field">
            <div class="input list">
              <div>浏览</div>
              <van-field type="number" v-model.number="actKpiVO.viewScore" />
            </div>
            <div class="input list">
              <div>裂变</div>
              <van-field type="number" v-model.number="actKpiVO.fissionScore" />
            </div>
          </div>
          <div class="field">
            <div class="input list">
              <div>报名</div>
              <van-field type="number" v-model.number="actKpiVO.enrollmentScore" />
            </div>
            <div class="input list">
              <div>售券</div>
              <van-field type="number" v-model.number="actKpiVO.cardScore" />
            </div>
          </div>
          <div class="field">
            <div class="input list">
              <div>秒杀</div>
              <van-field type="number" v-model.number="actKpiVO.seckillUserScore" />
            </div>
            <div class="input list">
              <div>集赞</div>
              <van-field type="number" v-model.number="actKpiVO.thumbScore" />
            </div>
          </div>
          <div class="field">
            <div class="input list">
              <div>进入直播间</div>
              <van-field type="number" v-model.number="actKpiVO.liveViewScore" />
            </div>
            <div class="input list">
              <div>直播下订</div>
              <van-field type="number" v-model.number="actKpiVO.liveOrderCusScore" />
            </div>
          </div>
          <div class="field">
            <div class="input list">
              <div>直播自签单</div>
              <van-field type="number" v-model.number="actKpiVO.liveSelfOrderScore" />
            </div>
            <div class="input list">
              <div>直播贡献单</div>
              <van-field type="number" v-model.number="actKpiVO.liveOtherOrderScore" />
            </div>
          </div>
          <div class="field">
            <div class="input list">
              <div>直播自签转单</div>
              <van-field type="number" v-model.number="actKpiVO.liveSelfOrderChangeScore" />
            </div>
            <div class="input list">
              <div>直播贡献转单</div>
              <van-field type="number" v-model.number="actKpiVO.liveOtherOrderChangeScore" />
            </div>
          </div>
          <div class="field">
            <div class="input list">
              <div>过程自签单</div>
              <van-field type="number" v-model.number="actKpiVO.processSelfOrderScore" />
            </div>
            <div class="input list">
              <div>过程贡献单</div>
              <van-field type="number" v-model.number="actKpiVO.processDevoteOrderScore" />
            </div>
          </div>
          <div class="field">
            <div class="input list">
              <div>直播预约</div>
              <van-field type="number" v-model.number="actKpiVO.appointmentScore" />
            </div>
          </div>
          <div class="btn">
            <van-button type="info" @click="saveDetail">积分设置</van-button>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <div class="home-over-btn">
      <router-link :to="{ name: 'kpi.home', query: { user_id: user_id, kpi_uid: kpi_userid,act_id: activity_id}}">
        <img src="https://j.weizan.cn/youxiang/images/home-over.png"/>
        首页
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activity_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      user_id: localStorage.getItem("user_id"),
      kpi_userid: localStorage.getItem("kpi_user_id") || null,
      share_userid: localStorage.getItem("share_user_id") || null,
      activity: {},
      // user_id: 0,
      kpi_uid: 0,
      share_uid: 0,
      user: null,
      kpi_user: null,
      kpi: {},
      stages: [],
      typeIndex: 0,
      types: [{ title: "品牌任务划分" }, { title: "奖励金设置" }],
      avatarUrl: "https://j.weizan.cn/youxiang/images/stage_img.png",
      StepList: [],
      actKpiVO: {
        viewBean: 0,
        fissionBean: 0,
        enrollmentBean: 0,
        appointmentBean: 0,
        cardBean: 0,
        thumbBean: 0,
        seckillUserBean: 0,
        processSelfOrderBean: 0,
        processDevoteOrderBean: 0,
        liveOrderCusBean: 0,
        liveSelfOrderBean: 0,
        liveOtherOrderBean: 0,
        liveSelfOrderChangeBean: 0,
        liveOtherOrderChangeBean: 0,
        liveViewBean: 0,
        viewScore: 0,
        fissionScore: 0,
        enrollmentScore: 0,
        cardScore: 0,
        thumbScore: 0,
        seckillUserScore: 0,
        processSelfOrderScore: 0,
        appointmentScore: 0,
        processDevoteOrderScore: 0,
        liveOrderCusScore: 0,
        liveSelfOrderScore: 0,
        liveOtherOrderScore: 0,
        liveSelfOrderChangeScore: 0,
        liveOtherOrderChangeScore: 0,
        liveViewScore: 0,
        maxBonus: 0,
        viewBonus: 0,
        fissionBonus: 0,
        enrollmentBonus: 0,
        seckillUserBonus: 0,
        processSelfOrderBonus: 0,
        processDevoteOrderBonus: 0,
        liveViewBonus: 0,
        cardBonus: 0,
        thumbBonus: 0,
        liveOrderCusBonus: 0,
        liveSelfOrderBonus: 0,
        liveOtherOrderBonus: 0,
        liveSelfOrderChangeBonus: 0,
        liveOtherOrderChangeBonus: 0,
        appointmentBonus: 0,
      },
      financeChargeConfigVO: {
        brandBonusBean: 0,
        staffBonusBean: 0,
        brandPenalty: 0,
        userShareBonus: 0,
        staffSingleBonus: 0,
        liveRedPackage: 0,
        otherPromotionExpenses: 0,
        staffBonus: 0,
      },
    };
  },
  computed: {
    type() {
      return this.typeIndex + 1;
    },
  },
  created() {
    this.getQueryStepList();
    this.getQueryBonusSettingDetail();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    addStage() {
      this.$router.push({
        name: "kpi-addstage",
        query: {
          activity_id: this.activity.id,
          user_id: this.user_id,
          kpi_uid: this.kpi_uid,
          share_uid: this.share_uid,
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
    async getQueryStepList() {
      let res = await this.$http.post("/v1/taskmanage/query_step_list");
      console.log(res);
      if (res.data && res.code == 0) {
        this.StepList = res.data.list;
      }
    },
    // 获取奖励金设置详情
    async getQueryBonusSettingDetail() {
      let res = await this.$http.post(
        "/v1/taskmanage/query_bonus_setting_detail"
      );
      console.log(res, 12131313131);
      if (res.data && res.code == 0) {
        this.actKpiVO = res.data.actKpiVO;
        this.financeChargeConfigVO = res.data.actAcountVO;
        this.financeChargeConfigVO.staffBonusBeanTotalPool = Number(
          this.financeChargeConfigVO.staffBonusBeanTotalPool
        ).add(this.financeChargeConfigVO.staffBonusTotalPool);
      }
    },
    async saveDetail() {
      let res = await this.$http.post(
        `/v1/taskmanage/update_act_kpi`,
        this.actKpiVO
      );
      console.log(res);
      if (res.data && res.code == 0) {
        this.$toast("设置成功！");
      }
    },
    editStage(stepId) {
      this.$router.push({
        name: "kpi-progress",
        query: {
          step_id: stepId,
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
    checkStage(stepId) {
      this.$router.push({
        name: "kpi-task",
        query: {
          step_id: stepId,
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },

    setType(index) {
      this.loading = false;
      this.finished = false;
      this.page = 1;
      this.types[this.typeIndex].list = [];
    },
  },
};
</script>

<style lang="less" scoped>
.bonus-pool-page {
  .bonus {
    /*奖金设置*/
    margin-top: 10px;
    .tip {
      background-color: #ffffff;
      text-align: center;
      font-weight: bold;
      line-height: 44px;
      margin-top: 10px;
    }

    .bonus-cell-group {
      /deep/.van-cell__value {
        /*金额显示*/
        color: #5293fd;
      }
    }

    .field {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #ffffff;
      .list {
        padding: 7px 15px;
        width: 50%;
        font-size: 12px;
      }
      .time {
        line-height: 24px;
        div:first-child {
          color: #999999;
        }
      }
      .input {
        position: relative;
        display: flex;
        padding: 7px 15px;
        box-sizing: border-box;
        align-items: center;
        justify-content: space-between;
        /deep/.van-cell {
          width: 30%;
          padding: 0px;
          /deep/.van-field__control {
            color: #5293fd;
            padding: 0 5px;
            line-height: 22px;
          }
          /deep/.van-field__control:hover,
          /deep/.van-field__control:focus {
            background-color: #eeeeee;
            border-radius: 2px;
          }
        }
      }
      .money {
        div {
          width: 50%;
        }
        div:last-child {
          text-align: right;
        }
        input {
          text-align: right;
          color: #5293fd;
          line-height: 22px;
          width: 50%;
          border: none;
        }
        /deep/input:hover,
        /deep/input:focus {
          text-align: left;
          background-color: #eeeeee;
          border-radius: 2px;
          border: none;
        }
      }
    }
  }

  .brand {
    /*品牌任务划分*/
    margin-top: 10px;
    .brand-info {
      display: flex;
      align-items: center;
      padding: 10px;
      background-color: #ffffff;
      img {
        width: 45px;
        min-width: 45px;
        height: 45px;
        vertical-align: bottom;
        border-radius: 50%;
        margin-right: 5px;
      }
      .info {
        font-size: 12px;
        display: flex;
        flex-direction: column;
        width: 100%;
        .info-right {
          margin-bottom: 5px;
          color: #5293fd;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
        }
        .name {
          font-weight: bold;
          font-size: 14px;
        }
        .word {
          color: #999999;
          margin-right: 5px;
        }
      }
    }
  }

  .btn,
  .sure-btn {
    width: 100%;
    padding: 15px 0;
    background-color: #ffffff;
    text-align: center;
    /deep/.van-button {
      width: 92%;
    }
  }
  .sure-btn {
    background-color: transparent;
    margin-top: 20px;
  }
}
</style>
